import employeeProfile from '@/api/employee-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  divisions: [],
  departments: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_DIVISIONS(state, divisions) {
    state.divisions = divisions
  },

  SET_DEPARTMENTS(state, departments) {
    state.departments = departments
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return employeeProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return employeeProfile.store(data)
  },

  async find(context, id) {
    return await employeeProfile.find(id)
  },

  update(context, data) {
    return employeeProfile.update(data)
  },

  destroy(context, id) {
    return employeeProfile.destroy(id)
  },

  async dataBeforeCreate({ commit, state }) {
    if (!state.divisions.length > 0) {
      let response = await employeeProfile.getdivision()
      commit('SET_DIVISIONS', response)
    }
    if (!state.departments.length > 0) {
      let response = await employeeProfile.getdepartment()
      commit('SET_DEPARTMENTS', response)
    }
  }
}
